import PasswordChangePanel from '../components/panels/PasswordChangePanel';
import Layout from '../layout';

const AdminPasswordPage = ({ routes }) => {
  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <PasswordChangePanel id="password" title="Change Admin Password" />
    </Layout>
  );
};

export default AdminPasswordPage;
